/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Dd_TagInputs */

const es_nav_dd_tag = /** @type {(inputs: Nav_Dd_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista 7ª`)
};

const gl_nav_dd_tag = /** @type {(inputs: Nav_Dd_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista 7ª`)
};

const en_nav_dd_tag = /** @type {(inputs: Nav_Dd_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List 7`)
};

/**
* | output |
* | --- |
* | "List 7" |
*
* @param {Nav_Dd_TagInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_dd_tag = /** @type {((inputs?: Nav_Dd_TagInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Dd_TagInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_dd_tag(inputs)
	if (locale === "en") return en_nav_dd_tag(inputs)
	return es_nav_dd_tag(inputs)
});